import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/master-link/demi-trader.png';

const _withScopeId = n => (_pushScopeId("data-v-5bf96e13"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  id: "about",
  class: "d-flex wrapper mx-auto"
};
const _hoisted_2 = {
  class: "flex-fill text-start"
};

const _hoisted_3 = /*#__PURE__*/_createTextVNode("關於 Demi Trader");

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "lh-lg fs-xl gray-60"
}, "裂縫中伸出了一只纏繞著繃帶的手，仔細一瞧，他手裡似乎拿著一節粉筆，朝著虛空中寫著看不懂的數學公式，隨著虛空中的數學公式越來越多，這只神秘的手，開始變化顏色，各種金融圖表、指數指標開始展現，有 K線圖、柱狀圖、折線圖 ...... 眼見這只手四周的虛空即將被寫滿時，從縫隙中傳出了一聲巨大聲響， Demily !")], -1));

const _hoisted_5 = {
  class: "d-flex"
};

const _hoisted_6 = /*#__PURE__*/_createTextVNode("瞭解更多");

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "flex-fill"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "demi trader"
})], -1));

export function render(_ctx, _cache) {
  const _component_landing_title = _resolveComponent("landing-title");

  const _component_button_link = _resolveComponent("button-link");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_landing_title, null, {
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  }), _hoisted_4, _createElementVNode("div", _hoisted_5, [_createVNode(_component_button_link, null, {
    default: _withCtx(() => [_hoisted_6]),
    _: 1
  })])]), _hoisted_7]);
}